/**
 * Helper
 */
var helper = require('../../helper');

$(function() {
    var $datatable = $('#datatable-guardians-payments'),
        guardianId =  $('input[name="guardianId"]').val(),
        columns = [
            {data: 'due_date', name: 'due_date'},
            {data: 'amount', name: 'amount'},
            {data: 'status', name: 'status', orderable: false, searchable: false},
            {data: 'amount_paid', name: 'amount_paid'},
            {data: 'outstanding_amount', name: 'outstanding_amount'},
            {data: 'payment_date', name: 'payment_date'},
            {data: 'property', name: 'property'},
            {data: 'rent_status', name: 'rent_status', orderable: false, searchable: false},
            { data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action" }
        ],
        $dt;

    $dt = $datatable.DataTable({
        "dom": "<'dt-toolbar dt-toolbar-no-buttons'lf>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": {
            "url": helper.getOrigin() + "/api/guardians/"+guardianId+"/payments",
            "method": 'POST',
            "data": function ( d ) {
                d.payment_status_id = $('input[name="clickedStatusId"]').val();
                d.overdue = $('input[name="overdue"]').val();
            }
        },
        "bAutoWidth" : false,
        "order": [[ 0, "desc" ]],
        "columns": columns
    });

    $('.js-payments-activity-box').on('click', function() {
        var $clickedStatusId = $('input[name="clickedStatusId"]'),
            $overdueField = $('input[name="overdue"]'),
            paymentStatusId = $(this).data('payment_status_id'),
            overdue = $(this).data('overdue');

        $clickedStatusId.val(paymentStatusId);
        $overdueField.val(overdue);

        $dt.ajax.reload();
    });

});
